import routerOptions0 from "/var/jenkins_home/workspace/qboson-web/node_modules/.pnpm/nuxt@3.8.0_eslint@8.57.1_rollup@4.53.3_sass@1.94.2_typescript@5.9.3_vite@4.5.14_vue-tsc@1.8.22/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}